import loadable from '@loadable/component';

export const CmsSubscribeButtonLoadable = loadable(
  () => import('./CmsSubscribeButton'),
  {
    resolveComponent: (module) => module.CmsSubscribeButton,
  },
);
